"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableDonutChart = void 0;
var tslib_1 = require("tslib");
var PluggablePieChart_1 = require("../pieChart/PluggablePieChart");
var donutChartUiConfigHelper_1 = require("../../../utils/uiConfigHelpers/donutChartUiConfigHelper");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var PluggableDonutChart = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableDonutChart, _super);
    function PluggableDonutChart(props) {
        var _this = _super.call(this, props) || this;
        _this.type = sdk_ui_1.VisualizationTypes.DONUT;
        return _this;
    }
    PluggableDonutChart.prototype.getExtendedReferencePoint = function (referencePoint) {
        return _super.prototype.getExtendedReferencePoint.call(this, referencePoint).then(donutChartUiConfigHelper_1.setDonutChartUiConfig);
    };
    return PluggableDonutChart;
}(PluggablePieChart_1.PluggablePieChart));
exports.PluggableDonutChart = PluggableDonutChart;
//# sourceMappingURL=PluggableDonutChart.js.map